<template>
  <div v-if="toastIsVisible">
    <div
      v-if="props.type === 'toast'"
      class="text-center text-white w-full py-2 px-4 absolute left-0"
      :class="{
        'bg-ryd-primary': props.theme === 'info',
        'bg-ryd-warning80': props.theme === 'warning',
        'button-caution-underline-text': props.theme === 'error',
      }"
    >
      <button class="absolute top-0 right-0 m-0 p-0" name="closeButton" @click.prevent="hideToast">
        <RydIcon icon="close" class="w-8 h-8 text-white" />
      </button>
      <slot></slot>
    </div>
    <div v-if="props.type === 'string'">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeMount, onMounted, ref } from 'vue';
import RydIcon from '../RydIcon/RydIcon.vue';

const props = defineProps({
  theme: {
    type: String,
    default: 'info',
    validator: value => ['info', 'warning', 'error'].includes(value as string)
  },
  position: {
    type: String,
    default: 'top'
  },
  duration: {
    type: Number,
    default: 3000
  },
  type: {
    type: String,
    default: 'toast',
    validator: value => ['toast', 'string'].includes(value as string)
  }
});

onMounted(() => {
  if (toastIsVisible.value) return;

  setTimeout(() => {

    toastIsVisible.value = false;
    emits('isHidden');

  }, props.duration);

  toastIsVisible.value = true;
});

const toastIsVisible = ref(false);

const hideToast = () => {
  toastIsVisible.value = false;
  emits('isHidden');
};
const emits = defineEmits(['isHidden']);
</script>